import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getReviews,
  isLoadingReviewsSelector,
  reviewsMetaSelector,
  reviewsSelector,
} from 'src/store/reviews';

import { ReviewsForm } from './reviewsForm/ReviewsForm';
import { ReviewItem } from './reviewItem/ReviewItem';
import { CustomPagination, PageLoader } from 'src/components';

import './reviews.scss';

export const Reviews = () => {
  const dispatch = useDispatch();

  const reviews = useSelector(reviewsSelector);
  const reviewsMeta = useSelector(reviewsMetaSelector);
  const isLoading = useSelector(isLoadingReviewsSelector);

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(getReviews());
  }, [dispatch]);

  const onChangePage = useCallback(
    (page) => {
      setCurrentPage(page);
      dispatch(getReviews({ page: page?.toString() }));
    },
    [dispatch],
  );

  return (
    <div className="reviews">
      {isLoading ? <PageLoader /> : null}

      <ReviewsForm />
      <div className="reviews__content">
        {reviews.map((item) => (
          <ReviewItem key={item.id} item={item} />
        ))}
      </div>
      <CustomPagination
        totalItems={reviewsMeta?.total_items}
        initialPage={currentPage}
        initialPerPage={reviewsMeta?.per_page}
        onPageChange={onChangePage}
        withSelect={false}
      />
    </div>
  );
};
